//# sourceMappingURL=organization.mjs.map
/// <reference types="./organization.d.mts" />
import * as $ask from "../../../altar/altar/ask.mjs";
import * as $invitation from "../../../data_types/data/auth/invitation.mjs";
import * as $organization from "../../../data_types/data/auth/organization.mjs";
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $tag from "../../../data_types/data/tag.mjs";
import * as $user from "../../../data_types/data/user.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $middleware from "../../admin/middleware.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { toList } from "../../gleam.mjs";

export function fetch_organizations() {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          dispatch(
            new $msg.Organizations(new $msg.ApiStartedLoadingOrganizations()),
          );
          let _pipe = $ask.to(new $ask.Admin(), toList(["organizations"]));
          let _pipe$1 = $ask.via(_pipe, new $http.Get());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.expect(
            _pipe$2,
            $decode.field(
              "total",
              $decode.int,
              (total) => {
                return $decode.field(
                  "organizations",
                  $decode.list($organization.decoder()),
                  (organizations) => {
                    return $decode.success([total, organizations]);
                  },
                );
              },
            ),
          );
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (organizations) => {
              let total = organizations[0];
              let organizations$1 = organizations[1];
              let _pipe$4 = new $msg.ApiReturnedOrganizations(
                total,
                organizations$1,
              );
              let _pipe$5 = new $msg.Organizations(_pipe$4);
              dispatch(_pipe$5);
              return undefined;
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (error) => {
              let _pipe$5 = error;
              let _pipe$6 = $string.inspect(_pipe$5);
              let _pipe$7 = ((_capture) => {
                return new $msg.ApiErroredOrganizations(_capture);
              })(_pipe$6);
              let _pipe$8 = new $msg.Organizations(_pipe$7);
              dispatch(_pipe$8);
              return undefined;
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

export function fetch_users(org_id) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          dispatch(
            new $msg.Organizations(
              new $msg.ApiStartedLoadingOrganizationsUsers(org_id),
            ),
          );
          let _pipe = $ask.to(
            new $ask.Admin(),
            toList(["organizations", org_id, "members"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Get());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.expect(
            _pipe$2,
            $decode.at(toList(["users"]), $decode.list($user.decoder())),
          );
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (users) => {
              let _pipe$4 = new $msg.ApiReturnedOrganizationsUsers(
                org_id,
                users,
              );
              let _pipe$5 = new $msg.Organizations(_pipe$4);
              dispatch(_pipe$5);
              return undefined;
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (error) => {
              let _pipe$5 = error;
              let _pipe$6 = $string.inspect(_pipe$5);
              let _pipe$7 = ((_capture) => {
                return new $msg.ApiErroredOrganizationsUsers(org_id, _capture);
              })(_pipe$6);
              let _pipe$8 = new $msg.Organizations(_pipe$7);
              dispatch(_pipe$8);
              return undefined;
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

export function fetch_invitations(org_id) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let $ = $store.organization_invitations(store);
          if ($ instanceof $remote.NotLoaded) {
            let _pipe = new $msg.ApiStartedLoadingOrganizationsInvitations(
              org_id,
            );
            let _pipe$1 = new $msg.Organizations(_pipe);
            dispatch(_pipe$1);
            undefined;
          } else if ($ instanceof $remote.Loading) {
            undefined;
          } else if ($ instanceof $remote.Errored) {
            undefined;
          } else {
            undefined;
          }
          let _pipe = $ask.to(
            new $ask.Admin(),
            toList(["organizations", org_id, "invitations"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Get());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.expect(
            _pipe$2,
            $decode.at(
              toList(["invitations"]),
              $decode.list($invitation.decoder()),
            ),
          );
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (invitations) => {
              let _pipe$4 = new $msg.ApiReturnedOrganizationsInvitations(
                org_id,
                invitations,
              );
              let _pipe$5 = new $msg.Organizations(_pipe$4);
              dispatch(_pipe$5);
              return undefined;
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (error) => {
              let _pipe$5 = error;
              let _pipe$6 = $string.inspect(_pipe$5);
              let _pipe$7 = ((_capture) => {
                return new $msg.ApiErroredOrganizationsInvitations(
                  org_id,
                  _capture,
                );
              })(_pipe$6);
              let _pipe$8 = new $msg.Organizations(_pipe$7);
              dispatch(_pipe$8);
              return undefined;
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

export function fetch_tags(org_id) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          dispatch(
            new $msg.Organizations(
              new $msg.ApiStartedLoadingOrganizationsTags(org_id),
            ),
          );
          let _pipe = $ask.to(
            new $ask.Admin(),
            toList(["organizations", org_id, "tags"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Get());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.expect(_pipe$2, $decode.list($tag.decoder()));
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (tags) => {
              let _pipe$4 = new $msg.ApiReturnedOrganizationsTags(org_id, tags);
              let _pipe$5 = new $msg.Organizations(_pipe$4);
              dispatch(_pipe$5);
              return undefined;
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (error) => {
              let _pipe$5 = error;
              let _pipe$6 = $string.inspect(_pipe$5);
              let _pipe$7 = ((_capture) => {
                return new $msg.ApiErroredOrganizationsTags(org_id, _capture);
              })(_pipe$6);
              let _pipe$8 = new $msg.Organizations(_pipe$7);
              dispatch(_pipe$8);
              return undefined;
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

export function fetch_connections(org_id) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = new $msg.ApiStartedLoadingOrganizationsConnections(org_id);
          let _pipe$1 = new $msg.Organizations(_pipe);
          dispatch(_pipe$1);
          let _pipe$2 = $ask.to(
            new $ask.Admin(),
            toList(["organizations", org_id, "connections"]),
          );
          let _pipe$3 = $ask.via(_pipe$2, new $http.Get());
          let _pipe$4 = $ask.bearing(_pipe$3, access_token);
          let _pipe$5 = $ask.expect(
            _pipe$4,
            $decode.at(
              toList(["connections"]),
              $decode.list($organization.connection_decoder()),
            ),
          );
          let _pipe$6 = $ask.on_success(
            _pipe$5,
            (connections) => {
              let _pipe$6 = new $msg.ApiReturnedOrganizationsConnections(
                org_id,
                connections,
              );
              let _pipe$7 = new $msg.Organizations(_pipe$6);
              dispatch(_pipe$7);
              return undefined;
            },
          );
          let _pipe$7 = $ask.on_error(
            _pipe$6,
            (error) => {
              let _pipe$7 = error;
              let _pipe$8 = $string.inspect(_pipe$7);
              let _pipe$9 = ((_capture) => {
                return new $msg.ApiErroredOrganizationsConnections(
                  org_id,
                  _capture,
                );
              })(_pipe$8);
              let _pipe$10 = new $msg.Organizations(_pipe$9);
              dispatch(_pipe$10);
              return undefined;
            },
          );
          return $ask.run(_pipe$7);
        },
      );
    },
  );
}

/**
 * Swaps the organization freshly returned by the API in the loaded list.
 * 
 * @ignore
 */
function replace_organization(dispatch, store, org_id) {
  return (organization) => {
    let $ = store.organizations;
    if ($ instanceof $remote.NotLoaded) {
      undefined;
    } else if ($ instanceof $remote.Loading) {
      undefined;
    } else if ($ instanceof $remote.Errored) {
      undefined;
    } else {
      let organizations = $[0];
      let count = organizations[0];
      let _block;
      let _pipe = organizations[1];
      _block = $list.map(
        _pipe,
        (o) => {
          let $1 = o.id === org_id;
          if ($1) {
            return organization;
          } else {
            return o;
          }
        },
      );
      let organizations$1 = _block;
      let _pipe$1 = new $msg.ApiReturnedOrganizations(count, organizations$1);
      let _pipe$2 = new $msg.Organizations(_pipe$1);
      dispatch(_pipe$2);
      undefined;
    }
    return undefined;
  };
}

export function update_feature_flags(org_id, feature_flags) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Admin(),
            toList(["organization", org_id, "feature_flags"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Post());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.json(
            _pipe$2,
            (() => {
              let _pipe$3 = feature_flags;
              return $json.array(_pipe$3, $organization.encode_feature_flag);
            })(),
          );
          let _pipe$4 = $ask.expect(_pipe$3, $organization.decoder());
          let _pipe$5 = $ask.on_success(
            _pipe$4,
            replace_organization(dispatch, store, org_id),
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

/**
 * Activates or deactivates an organization. A deactivated organization keeps
 * working as usual, but stops receiving notification emails.
 */
export function update_enabled(org_id, enabled) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Admin(),
            toList(["organization", org_id, "enabled"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Post());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.json(_pipe$2, $json.bool(enabled));
          let _pipe$4 = $ask.expect(_pipe$3, $organization.decoder());
          let _pipe$5 = $ask.on_success(
            _pipe$4,
            replace_organization(dispatch, store, org_id),
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}
